module.exports = __webpack_public_path__ + "static/media/RNSSanz-Medium.5502524a.ttf";